export default "__VITE_ASSET__tMeSp9yH__"